import ButtonBase from '@/global/components/Button/ButtonBase'
import IconeAjuda from '@/global/components/IconeAjuda'
import { SN } from '@acme/core'
import {
    ChevronLeftIcon,
    ChevronRightIcon,
    GitCompareArrowsIcon,
} from 'lucide-react'
import { useNoturnoPreview } from '../hooks/use-noturno-preview'

/**
 * Header da coluna de ações: popover com a prévia da redução noturna resolvida
 * das regras de cálculo do cliente, com stepper para ciclar entre configs
 * distintas. Componente próprio (não JSX inline no `renderHeader`) para ter
 * ciclo de vida de hooks e re-renderizar via store quando o índice muda — o
 * DataGrid memoiza o `renderHeader` e não o re-invoca.
 */
export function NoturnoPreviewHeader() {
    const { configs, idx, setIdx, noturno } = useNoturnoPreview()
    const total = configs.length

    return (
        <IconeAjuda className="mx-auto mt-2" Icon={<GitCompareArrowsIcon />}>
            <div className="w-xs">
                <p>
                    Você está visualizando a redução conforme configurado nas
                    regras de cálculo
                </p>
                <div className="w-full flex text-center items-center justify-center gap-2 pt-4 pb-6">
                    {total > 1 && (
                        <ButtonBase
                            variant="ghost"
                            size="icon"
                            aria-label="Config anterior"
                            onClick={() => setIdx((idx - 1 + total) % total)}
                        >
                            <ChevronLeftIcon />
                        </ButtonBase>
                    )}
                    <span className="font-medium select-none flex-1 max-w-8/10">
                        <span className="truncate block">
                            {noturno?.label ?? '—'}
                        </span>
                        {total > 1 && ` (${idx + 1}/${total})`}
                    </span>
                    {total > 1 && (
                        <ButtonBase
                            variant="ghost"
                            size="icon"
                            aria-label="Próxima config"
                            onClick={() => setIdx((idx + 1) % total)}
                        >
                            <ChevronRightIcon />
                        </ButtonBase>
                    )}
                </div>
                <table className="text-base border-collapse font-normal">
                    <tbody className="*:divide-x-8 *:divide-transparent">
                        <tr>
                            <td>Utiliza redução?</td>
                            <td className="font-bold">
                                {SN.format(noturno?.reducaoHrsATrabalhar)}
                            </td>
                        </tr>
                        <tr>
                            <td>Início do horário noturno</td>
                            <td className="font-bold">
                                {noturno?.horarioInicioAdicionalNoturno}
                            </td>
                        </tr>
                        <tr>
                            <td>Fim do horário noturno</td>
                            <td className="font-bold">
                                {noturno?.horarioFimAdicionalNoturno}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </IconeAjuda>
    )
}
